import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@heroui/react';
import { listParam } from '@/pages/catalogImport/notices';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type NameAxesProps = {
    /** The axes the import adds to the category, by name, in the preview's order. */
    axes: string[];
    isSelected: boolean;
    onChange: (isSelected: boolean) => void;
};

/**
 * "will add axes: Color, Storage" with a checkbox, ticked by default: the
 * variation axes the category's rows use that it lacks. Unticked, the
 * category is left as it is.
 */
export const NameAxes: React.FC<NameAxesProps> = ({
    axes,
    isSelected,
    onChange,
}) => {
    const { t } = useTranslation('pages');

    return (
        <Checkbox
            isSelected={isSelected}
            onChange={onChange}
            {...getNodeTestIdProp('catalog-import-names-axes')}
        >
            <Checkbox.Content>
                <Checkbox.Control>
                    <Checkbox.Indicator />
                </Checkbox.Control>
                {t('catalogImport.names.axes', { axes: listParam(axes) })}
            </Checkbox.Content>
        </Checkbox>
    );
};
